import styled from "styled-components";

type TextFieldType = {
  disabled?: boolean;
  maxWidth?: number;
};

export const StyledLabel = styled.label<TextFieldType>`
  font-family: ${({ theme }) => theme.fontFamily};
  font-size: ${({ theme }) => theme.fontSize.normal.desktop};
  max-width: ${({ maxWidth }) => maxWidth && `${maxWidth}px`};
  color: ${({ disabled, theme }) => disabled && theme.colors.disabled};
  display: flex;
  font-size: 0.9em;
  height: 20px;
  font-weight: ${({ theme }) => theme.fontWeight.bolder};
`;

export const StyledInput = styled.input<TextFieldType>`
  font-family: ${({ theme }) => theme.fontFamily};
  font-size: ${({ theme }) => theme.fontSize.normal.desktop};
  color: ${({ disabled, theme }) => disabled && theme.colors.disabled};
  cursor: ${({ disabled }) => disabled && "not-allowed"};
  display: flex;
  border: 2px solid #e7e7e7;
  border-radius: 6px;
  width: calc(100% - 24px);
  resize: none;
  padding: 10px;
  position: relative;
  margin: 5px 0 15px 0;
  max-width: ${({ maxWidth }) => maxWidth && `${maxWidth}px`};

  &::placeholder {
    font-weight: ${({ theme }) => theme.fontWeight.light};
    color: ${({ disabled, theme }) => disabled && theme.colors.disabled};
  }

  &:focus {
    border-color: #f2008c;
    outline: none;
    box-shadow: inset 0 1px 1px rgb(0 0 0 / 8%), 0 0 8px rgb(233 102 163 / 60%);
  }
`;

StyledInput.displayName = "StyledInput";

export const Required = styled.span<TextFieldType>`
  &:after {
    content: "*";
    color: ${({ disabled, theme }) =>
      disabled ? theme.colors.disabled : theme.colors.primary};
    font-weight: 300;
    font-size: 2em;
    position: relative;
    top: -2px;
    left: 5px;
  }
`;
